import React, { useState } from 'react';
import { PriceProduct } from '../types/costwand.d';
import { usePrices } from '../hooks/usePrices.ts';
import PriceTable from '../components/PriceTable.tsx';
import { Button } from '../components/ui/button.tsx';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
  DialogFooter,
} from '../components/ui/dialog.tsx';

const PricesPage = () => {
  const {
    prices,
    loading,
    error,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    // Assuming no create/update/delete for prices directly from this page,
    // as prices are typically derived from products or composites.
    // If there were, they would be implemented here.
  } = usePrices();

  // No form or editing functionality for prices page as they are usually read-only representations.

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-secondary-foreground">Product Prices</h2>
        {/* No "Add New Price" button as prices are derived */}
      </div>

      <PriceTable
        prices={prices}
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        loading={loading}
        error={error}
        baseEndpoint="/prices" // NEW: Pass the base endpoint
      />
    </div>
  );
};

export default PricesPage;